/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ifNotAuthenticated } from '../routeValidation';
import AuthenticationLayout from '@/views/Layout/AuthenticationLayout.vue';
import { ROUTES } from './routes';

const { SETUP_PASSWORD, SETUP_PASSWORD_CODE, } = ROUTES;
const setupPassword = () =>
  import(/* webpackChunkName: "SetupPassword" */ '@/views/ForgotPassword/setupPassword.vue');

export default {
  path: SETUP_PASSWORD.route,
  component: AuthenticationLayout,
  beforeEnter: ifNotAuthenticated,
  children: [
    {
      path: SETUP_PASSWORD_CODE.route,
      name: SETUP_PASSWORD_CODE.name,
      component: setupPassword,
    }
  ],
};
